import axios from 'axios'
import store from '../store'

let getOptionToken = null
let getOptionsToken = null
let getCartOptionsToken = null

export default {
  methods: {
    async getOptionById(optionId, locationId) {
      if (getOptionToken) {
        getOptionToken.cancel()
      }
      getOptionToken = axios.CancelToken.source()

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}`,
        {
          cancelToken: getOptionToken.token,

          params: {
            locationid: locationId,
          },

          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async getLocationOptions(
      locationId = 0,
      categoryId = 0,
      searchTerm = '',
      page = 0,
      itemsPerPage = 0
    ) {
      if (getOptionsToken) {
        getOptionsToken.cancel()
      }
      getOptionsToken = axios.CancelToken.source()

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location/${locationId}`,
        {
          cancelToken: getOptionsToken.token,
          params: {
            categoryId: categoryId,
            q: searchTerm,
            page: page,
            itemsPerPage: itemsPerPage,
          },

          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async getLocationOptionsWithInventory(locationId) {
      if (getOptionsToken) {
        getOptionsToken.cancel()
      }
      getOptionsToken = axios.CancelToken.source()

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location/${locationId}/inventory`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async getOptionInventory(optionId, locationId, year, month, day) {
      if (getOptionsToken) {
        getOptionsToken.cancel()
      }
      getOptionsToken = axios.CancelToken.source()

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/inventory`,
        {
          cancelToken: getOptionsToken.token,
          params: {
            locationId: locationId,
            year: year,
            month: month,
            day: day,
          },

          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionSettings(optionLocation) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionLocation.OptionId}/settings`,
        optionLocation,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionImage(optionId, locationId, imageName) {
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/image`,
        JSON.stringify({
          Image: imageName,
          LocationId: locationId,
        }),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionChannels(optionId, locationId, channels) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/channels`,
        JSON.stringify({
          OptionId: optionId,
          LocationId: locationId,
          Channels: channels,
        }),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionMeetingtypes(optionId, locationId, meetingtypes) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/meetingtypes`,
        JSON.stringify({
          OptionId: optionId,
          LocationId: locationId,
          Meetingtypes: meetingtypes,
        }),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionPrices(optionId, locationId, prices) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/prices`,
        JSON.stringify({
          OptionId: optionId,
          LocationId: locationId,
          Prices: prices,
        }),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationOptionTexts(optionId, locationId, texts) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/texts`,
        JSON.stringify({
          OptionId: optionId,
          LocationId: locationId,
          Texts: texts,
        }),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async getReservationOptions(
      reservationId,
      date,
      categoryId = 0,
      searchTerm = ''
    ) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/reservation/${reservationId}/available/options`,
        {
          params: {
            date,
            q: searchTerm,
            cat: categoryId,
          },
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveOptionBase(optionId, optionBase) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/${optionId}/base`,
        optionBase,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async createLocationOption(newOption) {
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location`,
        JSON.stringify(newOption),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async createLocationOptionBulk(locationId, newOptions) {
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location/${locationId}/bulk`,
        newOptions,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async getLocationRankedOptions(locationId, meetingtypeId = 0) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location/${locationId}/ranked`,
        {
          params: {
            meetingtypeId: meetingtypeId,
          },

          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveLocationRankedOptions(locationId, options) {
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/option/location/${locationId}/ranked`,
        JSON.stringify(options),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async deleteLocationOption(optionId, locationId) {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/Option/${optionId}/location/${locationId}`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveOptionInventory(optionId, exceptions) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/Option/${optionId}/inventory`,
        JSON.stringify(exceptions),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },

    async saveOptionLocationDays(optionId, locationId, days) {
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/Option/${optionId}/days`,
        days,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken'],
          },
        }
      )
      return response
    },
  },
}
